import ColorBox from 'components/shared/colorBox';
import { ReactComponent as DashboardIcon } from '../assets/icons/widgets.svg';
import { ReactComponent as AlignmentIcon } from '../assets/icons/pending_actions.svg';
import { ReactComponent as ActionPlansIcon } from '../assets/icons/assignment.svg';
import { ReactComponent as MyPrivateNotesIcon } from '../assets/icons/person_pin.svg';
import { ReactComponent as UserGroupIcon } from '../assets/icons/people.svg';
import { ReactComponent as OneOnOneReportIcon } from '../assets/icons/insights.svg';
import { ReactComponent as AttributeReportIcon } from '../assets/icons/details.svg';
import { ReactComponent as LearningIcon } from '../assets/icons/school.svg';
import { ReactComponent as AnnouncementsIcon } from '../assets/icons/campaign_gray.svg';
import { ReactComponent as ReviewIcon } from '../assets/icons/star-icon.svg';
import { ReactComponent as StatsIcon } from '../assets/icons/show_chart.svg';
import { ReactComponent as CompareIcon } from '../assets/icons/bar_chart.svg';
import { ReactComponent as SurveysIcon } from '../assets/icons/message.svg';
import { ReactComponent as AttributesIcon } from '../assets/icons/fact_check.svg';
import { ReactComponent as SurveysHistoryIcon } from '../assets/icons/rate_review.svg';
import { ReactComponent as CareerIcon } from '../assets/icons/landscape.svg';
import { ReactComponent as LevelingIcon } from '../assets/icons/trending_up.svg';
import { ReactComponent as JobTitlesIcon } from '../assets/icons/title-grey.svg';
import { ReactComponent as CompanyIcon } from '../assets/icons/group_work.svg';
import { ReactComponent as PeopleIcon } from '../assets/icons/groups-grey.svg';
import { ReactComponent as DivisionsIcon } from '../assets/icons/account_tree.svg';
import { ReactComponent as OrgChartIcon } from '../assets/icons/table_chart.svg';
import { ReactComponent as TagsIcon } from '../assets/icons/tag.svg';
import { ReactComponent as ReportsIcon } from '../assets/icons/graphic_eq.svg';
import { ReactComponent as CompanyOverviewIcon } from '../assets/icons/dashboard.svg';
import { ReactComponent as ComparePeopleIcon } from '../assets/icons/compare-light-grey.svg';
import { ReactComponent as SurveySummaryIcon } from '../assets/icons/topic-icon-gray.svg';
import { ReactComponent as AbsenceIcon } from '../assets/icons/event_available.svg';
import { ReactComponent as AbsenceSetsIcon } from '../assets/icons/event_note_light_gray.svg';
import { ReactComponent as AbsenceCalendarIcon } from '../assets/icons/calendar-icon-gray.svg';
import { ReactComponent as RecruitmentIcon } from '../assets/icons/business_center.svg';
import { ReactComponent as RecruitmentJobsIcon } from '../assets/icons/call_to_action.svg';
import { ReactComponent as TimeToHireIcon } from '../assets/icons/timelapse.svg';
import { ReactComponent as AbsenceRequestsIcon } from '../assets/icons/work_off_light_gray.svg';
import { ReactComponent as CyclesIcon } from '../assets/icons/sync_small_gray.svg';
import { ReactComponent as HeadcountIcon } from '../assets/icons/grid_on.svg';
import { ReactComponent as AbsenceReportIcon } from '../assets/icons/date_range.svg';
import { ReactComponent as SuccessionIcon } from '../assets/icons/workspace_premium_gray.svg';
import { PERMISSION_CODES } from '../constants/permissions';
import { isArray, isArrayEmpty } from './helpers';
import {
  hasAuthPermissionsCheck,
  hasScopedAuthPermissionCheck,
} from './permissions';

export const getSidebarNavigationItems = (
  classes,
  labels,
  user,
  accessControl,
  organizationSettings,
  organizationMenuSetup
) => {
  const {
    ANNOUNCEMENTS_VIEW,
    PLANS_VIEW,
    ONE_ON_ONE_VIEW,
    LEARNING_VIEW,
    CYCLES_VIEW,
    SURVEYS_VIEW_ALL,
    SURVEYS_VIEW_CREATED,
    REPORTS_COMPETENCE_MAP_VIEW,
    REPORTS_ABSENCE_VIEW,
    REPORTS_SKILLS_MATRIX_VIEW,
    REPORTS_GENERAL_MOOD_VIEW,
    REPORTS_COMPARE_VIEW,
    REPORTS_ATTRIBUTE_VIEW,
    REPORTS_HEADCOUNT_VIEW,
    REPORTS_OVERVIEW_VIEW,
    LEVELING_VIEW,
    JOB_TITLES_VIEW,
    ABSENCE_VIEW,
    ABSENCE_SETTINGS_MANAGE,
    DEPARTMENTS_VIEW,
    TAGS_VIEW,
    RECRUITMENT_VIEW,
    RECRUITMENT_EDIT,
    ATTRIBUTES_VIEW,
    SUCCESSION_MANAGE,
  } = PERMISSION_CODES;
  const {
    users_see_absence,
    users_see_courses,
    users_see_recruitment,
    users_see_succession,
  } = organizationSettings;
  const [
    canViewAnnouncements,
    canViewActionPlans,
    canViewOneOnOne,
    canViewCourses,
    canViewCycles,
    canViewAllSurveys,
    canViewCreatedSurveys,
    canViewReportsCompetenceMap,
    canViewReportsAbsence,
    canViewReportsSkillsMatrix,
    canViewReportsGeneralMood,
    canViewReportsCompare,
    canViewReportsAttribute,
    canViewReportsHeadcount,
    canViewReportsCompanyOverview,
    canViewLeveling,
    canViewJobTitles,
    canViewAbsence,
    canManageAbsenceSettings,
    canViewDepartments,
    canViewTags,
    canViewRecruitment,
    canEditRecruitment,
    canViewAttributes,
    canManageSuccession,
  ] = hasAuthPermissionsCheck(
    [
      ANNOUNCEMENTS_VIEW,
      PLANS_VIEW,
      ONE_ON_ONE_VIEW,
      LEARNING_VIEW,
      CYCLES_VIEW,
      SURVEYS_VIEW_ALL,
      SURVEYS_VIEW_CREATED,
      REPORTS_COMPETENCE_MAP_VIEW,
      REPORTS_ABSENCE_VIEW,
      REPORTS_SKILLS_MATRIX_VIEW,
      REPORTS_GENERAL_MOOD_VIEW,
      REPORTS_COMPARE_VIEW,
      REPORTS_ATTRIBUTE_VIEW,
      REPORTS_HEADCOUNT_VIEW,
      REPORTS_OVERVIEW_VIEW,
      LEVELING_VIEW,
      JOB_TITLES_VIEW,
      ABSENCE_VIEW,
      ABSENCE_SETTINGS_MANAGE,
      DEPARTMENTS_VIEW,
      TAGS_VIEW,
      RECRUITMENT_VIEW,
      RECRUITMENT_EDIT,
      ATTRIBUTES_VIEW,
      SUCCESSION_MANAGE,
    ],
    accessControl
  );
  const childrenSection = [];

  if (user?.id) {
    return [
      {
        id: 1,
        title: labels.dashboard.title,
        url: '/',
        icon: DashboardIcon,
      },
      ...(canViewAnnouncements
        ? [
            {
              id: 2,
              title: labels.announcements.title,
              url: '/announcements',
              icon: AnnouncementsIcon,
            },
          ]
        : []),
      {
        id: 3,
        title: labels.alignment.title,
        icon: AlignmentIcon,
        items: [
          ...(users_see_courses && canViewCourses
            ? [
                {
                  title: labels.learning.title,
                  url: 'learning',
                  icon: LearningIcon,
                },
              ]
            : []),
          ...(canViewActionPlans
            ? [
                {
                  title: labels.alignment.items.actionPlans,
                  url: '/action-plans',
                  icon: ActionPlansIcon,
                },
              ]
            : []),
          {
            title: labels.alignment.items.myPrivateNotes,
            url: '/my-private-notes',
            icon: MyPrivateNotesIcon,
          },
          ...(canViewOneOnOne
            ? [
                {
                  title: labels.alignment.items.oneOnOne,
                  url: '/1-1',
                  icon: UserGroupIcon,
                },
              ]
            : []),
        ],
      },
      {
        id: 4,
        title: labels.review.title,
        icon: ReviewIcon,
        items: [
          ...(canViewCycles
            ? [
                {
                  title: labels.review.items.cycles,
                  url: 'cycles',
                  icon: CyclesIcon,
                },
              ]
            : []),
          ...(canViewAllSurveys || canViewCreatedSurveys
            ? [
                {
                  title: labels.review.items.surveys,
                  url: 'surveys',
                  icon: SurveysIcon,
                },
              ]
            : []),
          ...(canViewAttributes
            ? [
                {
                  title: labels.review.items.attributes,
                  url: 'attributes',
                  icon: AttributesIcon,
                },
              ]
            : []),
          {
            title: labels.review.items.surveyHistory,
            url: 'survey-history',
            icon: SurveysHistoryIcon,
          },
        ],
      },
      {
        id: 5,
        title: labels.reports.title,
        icon: ReportsIcon,
        items: [
          ...(canViewReportsCompanyOverview
            ? [
                {
                  title: labels.reports.items.companyOverview,
                  url: '/reports/company-overview',
                  icon: CompanyOverviewIcon,
                },
              ]
            : []),
          ...(canViewReportsHeadcount
            ? [
                {
                  title: labels.reports.items.headcountReport,
                  url: '/reports/headcount',
                  icon: HeadcountIcon,
                },
              ]
            : []),
          ...(canViewReportsAbsence && users_see_absence
            ? [
                {
                  title: labels.reports.items.absenceReport,
                  url: '/reports/absence',
                  icon: AbsenceReportIcon,
                },
              ]
            : []),
          ...(canViewReportsCompetenceMap
            ? [
                {
                  title: labels.reports.items.stats,
                  url: '/reports/competence-map',
                  icon: StatsIcon,
                },
              ]
            : []),
          ...(canViewReportsSkillsMatrix
            ? [
                {
                  title: labels.reports.items.skillsMatrix,
                  url: '/reports/skills-matrix',
                  icon: CompareIcon,
                },
              ]
            : []),
          ...(canViewReportsGeneralMood
            ? [
                {
                  title: labels.reports.items.oneOnOneReport,
                  url: '/reports/general-mood',
                  icon: OneOnOneReportIcon,
                },
              ]
            : []),
          ...(canViewReportsAttribute
            ? [
                {
                  title: labels.reports.items.attribute,
                  url: '/reports/attribute',
                  icon: AttributeReportIcon,
                },
              ]
            : []),
          ...(canViewReportsCompare
            ? [
                {
                  title: labels.reports.items.compare,
                  url: '/reports/compare',
                  icon: ComparePeopleIcon,
                },
              ]
            : []),
          {
            title: labels.reports.items.surveySummary,
            url: '/reports/survey-summary',
            icon: SurveySummaryIcon,
          },
        ],
      },
      ...(canViewLeveling ||
      canViewJobTitles ||
      (users_see_succession && canManageSuccession)
        ? [
            {
              id: 6,
              title: labels.career.title,
              icon: CareerIcon,
              items: [
                ...(canViewLeveling
                  ? [
                      {
                        title: labels.career.items.leveling,
                        url: 'levels-and-tracks',
                        icon: LevelingIcon,
                      },
                    ]
                  : []),
                ...(canViewJobTitles
                  ? [
                      {
                        title: labels.career.items.jobTitles,
                        url: 'job-titles',
                        icon: JobTitlesIcon,
                      },
                    ]
                  : []),
                ...(users_see_succession && canManageSuccession
                  ? [
                      {
                        title: labels.career.items.succession,
                        url: 'succession',
                        icon: SuccessionIcon,
                      },
                    ]
                  : []),
              ],
            },
          ]
        : []),
      ...(users_see_absence && canViewAbsence
        ? [
            {
              id: 7,
              title: labels.absence.title,
              icon: AbsenceIcon,
              items: [
                {
                  title: labels.absence.items.calendar,
                  url: '/absence/calendar',
                  icon: AbsenceCalendarIcon,
                },
                {
                  title: labels.absence.items.requests,
                  url: '/absence/requests',
                  icon: AbsenceRequestsIcon,
                },
                ...(canManageAbsenceSettings
                  ? [
                      {
                        title: labels.absence.items.settings,
                        url: '/absence/settings',
                        icon: AbsenceSetsIcon,
                      },
                    ]
                  : []),
              ],
            },
          ]
        : []),
      ...(users_see_recruitment && canViewRecruitment
        ? [
            {
              id: 8,
              title: labels.recruitment.title,
              icon: RecruitmentIcon,
              items: [
                {
                  title: labels.recruitment.items.jobs,
                  url: 'jobs',
                  icon: RecruitmentJobsIcon,
                },
                ...(canEditRecruitment
                  ? [
                      {
                        title: labels.recruitment.items.candidates,
                        url: 'candidates',
                        icon: UserGroupIcon,
                      },
                      {
                        title: labels.recruitment.items.timeToHire,
                        url: 'time-to-hire',
                        icon: TimeToHireIcon,
                      },
                    ]
                  : []),
              ],
            },
          ]
        : []),
      {
        id: 9,
        title: labels.company.title,
        icon: CompanyIcon,
        items: [
          {
            title: labels.company.items.people,
            url: 'people',
            icon: PeopleIcon,
          },
          ...(canViewDepartments
            ? [
                {
                  title: labels.company.items.divisions,
                  url: 'divisions-and-departments',
                  icon: DivisionsIcon,
                },
              ]
            : []),
          {
            title: labels.company.items.orgChart,
            url: 'org-chart',
            icon: OrgChartIcon,
          },
          ...(canViewTags
            ? [
                {
                  title: labels.company.items.tags,
                  url: 'tags',
                  hasChildren: true,
                  icon: TagsIcon,
                },
              ]
            : []),
          ...(canViewTags &&
          isArray(organizationMenuSetup) &&
          !isArrayEmpty(organizationMenuSetup)
            ? organizationMenuSetup?.map(filter => {
                const url = `tags/${filter.id}/people`;
                childrenSection.push(url);
                return {
                  title: filter.name,
                  hasParent: true,
                  icon: () => {
                    return <ColorBox className={classes.colorBox} isSmall />;
                  },
                  url,
                };
              }) || {}
            : []),
        ],
        childrenSection,
      },
    ];
  }
  return [];
};

export const getUserProfileNavigationItems = (
  id,
  auth,
  accessControl,
  organizationSettings
) => {
  const canViewActionPlans = hasScopedAuthPermissionCheck(
    PERMISSION_CODES.PLANS_VIEW,
    accessControl,
    auth.id,
    id
  );
  const canViewCourses = hasScopedAuthPermissionCheck(
    PERMISSION_CODES.LEARNING_VIEW,
    accessControl,
    auth.id,
    id
  );
  const canViewAbsences = hasScopedAuthPermissionCheck(
    PERMISSION_CODES.ABSENCE_VIEW,
    accessControl,
    auth.id,
    id
  );
  const canViewOneOnOne = hasScopedAuthPermissionCheck(
    PERMISSION_CODES.ONE_ON_ONE_VIEW,
    accessControl,
    auth.id,
    id
  );

  const canViewDocuments = hasScopedAuthPermissionCheck(
    PERMISSION_CODES.PROFILES_DOCUMENTS_VIEW,
    accessControl,
    auth.id,
    id
  );

  return [
    {
      url: `/people/${id}`,
      name: 'Career',
      translationKey: 'career',
      isVisibleToCurrentUser: true,
      hasOrganizationalVisibility: true,
      end: true,
    },
    {
      url: `/people/${id}/insights`,
      name: 'Insights',
      translationKey: 'insights',
      isVisibleToCurrentUser: true,
      hasOrganizationalVisibility: true,
      end: false,
    },
    {
      url: `/people/${id}/review-cycles`,
      name: 'Review cycles',
      translationKey: 'reviewCycles',
      isVisibleToCurrentUser: true,
      hasOrganizationalVisibility: true,
      end: false,
    },
    {
      url: `/people/${id}/roles`,
      name: 'Roles',
      translationKey: 'roles',
      isVisibleToCurrentUser: true,
      hasOrganizationalVisibility: true,
      end: false,
    },
    ...(canViewActionPlans
      ? [
          {
            url: `/people/${id}/action-plans`,
            name: 'Action plans',
            translationKey: 'actionPlans',
            isVisibleToCurrentUser: true,
            hasOrganizationalVisibility: true,
            end: false,
          },
        ]
      : []),
    ...(canViewCourses
      ? [
          {
            url: `/people/${id}/learning`,
            name: 'Learning',
            translationKey: 'learning',
            isVisibleToCurrentUser: true,
            hasOrganizationalVisibility:
              organizationSettings?.users_see_courses,
            end: false,
          },
        ]
      : []),
    {
      url: `/people/${id}/notes`,
      name: 'Notes',
      translationKey: 'notes',
      isVisibleToCurrentUser: false,
      hasOrganizationalVisibility: true,
      end: false,
    },
    ...(canViewOneOnOne
      ? [
          {
            url: `/people/${id}/one-on-one`,
            name: '1:1',
            translationKey: 'oneOnOne',
            isVisibleToCurrentUser: true,
            hasOrganizationalVisibility: true,
            end: false,
          },
        ]
      : []),

    ...(canViewAbsences
      ? [
          {
            url: `/people/${id}/absences`,
            name: 'Absences',
            translationKey: 'absences',
            isVisibleToCurrentUser: true,
            hasOrganizationalVisibility:
              organizationSettings?.users_see_absence,
            end: false,
          },
        ]
      : []),
    {
      url: `/people/${id}/general-info`,
      name: 'Info',
      translationKey: 'generalInfo',
      isVisibleToCurrentUser: true,
      hasOrganizationalVisibility: true,
      end: false,
    },
    ...(canViewDocuments
      ? [
          {
            url: `/people/${id}/documents`,
            name: 'Documents',
            translationKey: 'documents',
            isVisibleToCurrentUser: true,
            hasOrganizationalVisibility: true,
            end: false,
          },
        ]
      : []),
  ];
};
